import { TFunction } from 'i18next';
import { ApiToken } from 'graphql-common';
import { NavItem, NavItemTypeEnum } from '@lib/components/Menu/Menu';
import Icons from '@lib/components/Icons/Icons';

type ActionsMenuArgs = {
  onDelete: (v?: ApiToken) => void;
  onEdit: (v?: ApiToken) => void;
  t: TFunction<'translation', undefined>;
};

export default function getTableActionsMenu({
  onDelete,
  onEdit,
  t,
}: ActionsMenuArgs): NavItem<ApiToken>[] {
  return [
    {
      id: 'edit-label',
      title: t('edit-label'),
      onClick: (item?: ApiToken) => onEdit(item),
      leftIcon: Icons.edit,
      type: NavItemTypeEnum.Secondary,
    },
    {
      id: 'delete-action',
      title: t('delete'),
      onClick: (item?: ApiToken) => onDelete(item),
      leftIcon: Icons.delete,
      type: NavItemTypeEnum.Secondary,
    },
  ];
}
